import React from "react";
import { useTranslation } from "react-i18next";
import Card from "../generic/Card";

function FormatsSection() {
  const { t } = useTranslation();

  const formats = [
    {
      id: "format1",
      icon: "fas fa-hand-rock",
      title: t("taolu_formats.format1.title"),
      description: t("taolu_formats.format1.description"),
    },
    {
      id: "format2",
      icon: "fas fa-khanda",
      title: t("taolu_formats.format2.title"),
      description: t("taolu_formats.format2.description"),
    },
    {
      id: "format3",
      icon: "fas fa-user-group",
      title: t("taolu_formats.format3.title"),
      description: t("taolu_formats.format3.description"),
    },
    {
      id: "format4",
      icon: "fas fa-users",
      title: t("taolu_formats.format4.title"),
      description: t("taolu_formats.format4.description"),
    },
  ];

  return (
    <section
      className="relative z-10 bg-white pb-14 pt-12 transition-colors dark:bg-slate-800 md:pb-16 md:pt-14"
      id="formats-section"
      aria-labelledby="taolu-formats-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="mb-10 text-center md:mb-12">
          <h2
            id="taolu-formats-heading"
            className="relative mb-5 inline-block text-4xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-5xl"
          >
            {t("taolu_formats.title")}
            <span
              className="absolute -bottom-2.5 left-1/2 h-0.5 w-16 -translate-x-1/2 rounded-full bg-primary dark:bg-primary-light"
              aria-hidden
            />
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-pretty text-lg leading-relaxed text-slate-600 dark:text-slate-400">
            {t("taolu_formats.intro")}
          </p>
        </header>

        <ul className="m-0 grid list-none grid-cols-1 gap-5 p-0 sm:grid-cols-2 md:gap-6 xl:grid-cols-4">
          {formats.map((item) => (
            <li key={item.id} className="min-h-0">
              <Card
                icon={item.icon}
                title={item.title}
                description={item.description}
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default FormatsSection;
